import { Map, List } from 'immutable';

import BaseStore from './BaseStore';
import { sum } from '../helpers/Immutable';
import { ActionTypes } from '../constants/AppConstants';
import { resolveAll } from '../helpers/LinkMapper';
import Voucher from '../records/customer/Voucher';

class VoucherStore extends BaseStore {

    getInitialState () {
        return new Map({
            failed: false,
            loading: false,
            vouchers: new List()
        });
    }

    deserialize (serialized) {
        if (serialized) {
            return new Map({
                failed: false,
                loading: false,
                vouchers: resolveAll(serialized.fares).as(Voucher),
            });
        }

        return this.getInitialState();
    }

    getActionHandlers () {
        return {
            [ ActionTypes.CUSTOMER_VOUCHERS_STARTED ]: this.handleStarted,
            [ ActionTypes.CUSTOMER_VOUCHERS_LOADED ]: this.handleLoaded,
            [ ActionTypes.CUSTOMER_VOUCHERS_FAILED ]: this.handleFailed,
            [ ActionTypes.LOGGED_OUT ]: this.resetState
        };
    }

    handleStarted () {
        this.setState(this.state
            .set('failed', false)
            .set('loading', true));
    }

    handleLoaded ({ vouchers }) {
        this.setState(this.state
            .set('failed', false)
            .set('loading', true)
            .set('vouchers', vouchers.sortBy((voucher) => voucher.expiry.unix())));
    }

    handleFailed () {
        this.setState(this.state
            .set('failed', true)
            .set('loading', false));
    }

    getTotal () {
        return sum(this.get('vouchers'), 'amount');
    }

}


const instance = new VoucherStore({ storageKey: 'vouchers' });

export default instance;
